import axios, { getData } from "lib/axios";
import { useQuery, useMutation, useQueryClient } from "react-query";

export const getLeavePolicies = async () => {
  return axios.get("/admin/leave-policy");
};

export const useShowLeavePolicy = (id) =>
  useQuery(["leave-policy", id], async () => {
    const res = await axios.get(`/admin/leave-policy/${id}`).then(getData);
    return res.data[0];
  });

export const usePutLeavePolicyStatus = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ id, status, type }) => {
      const res = await axios.put(`/admin/leave-policy/status/${id}`, {
        status: status,
      });
      return res;
    },
    {
      onSuccess: (data, { type }) => {
        if (type === 3) {
          queryClient.invalidateQueries(["leave-policy", { type: 3 }]);
          queryClient.invalidateQueries("entitlement");
          queryClient.invalidateQueries("disabled-date");
        } else {
          queryClient.invalidateQueries("leave-policy");
          queryClient.invalidateQueries("entitlement");
          queryClient.invalidateQueries("disabled-date");
        }
      },
    }
  );
};
export const usePutLeavePolicy = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ id, data, type }) => {
      const res = await axios.put(`/admin/leave-policy/${id}`, data);
      return res;
    },
    {
      onSuccess: (data, { type }) => {
        if (type === 3) {
          queryClient.invalidateQueries(["leave-policy", { type: 3 }]);
          queryClient.invalidateQueries("entitlement");
          queryClient.invalidateQueries("disabled-date");
        } else {
          queryClient.invalidateQueries("leave-policy");
          queryClient.invalidateQueries("entitlement");
          queryClient.invalidateQueries("disabled-date");
        }
      },
    }
  );
};

export const usePostNewLeavePolicy = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const res = await axios.post(`/admin/leave-policy`, data);
      return res;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("leave-policy");
        queryClient.invalidateQueries("entitlement");
        queryClient.invalidateQueries("disabled-date");
      },
    }
  );
};

export const useDeleteLeavePolicy = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (id) => {
      const res = await axios.delete(`/admin/leave-policy/${id}`);
      return res;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("leave-policy");
        queryClient.invalidateQueries("entitlement");
        queryClient.invalidateQueries("disabled-date");
      },
    }
  );
};
